function setLoggedIn (token, businessPartnerId) {
  window.localStorage.setItem('token', 'Bearer ' + token)
  window.localStorage.setItem('businessPartnerId', businessPartnerId)
}

export default setLoggedIn
